import { render, staticRenderFns } from "./TenderDetails.vue?vue&type=template&id=1d79152e&scoped=true&"
import script from "./TenderDetails.vue?vue&type=script&lang=js&"
export * from "./TenderDetails.vue?vue&type=script&lang=js&"
import style0 from "./TenderDetails.vue?vue&type=style&index=0&id=1d79152e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79152e",
  null
  
)

export default component.exports